import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Button, Text } from '@beef/ui-kit';
import Icon from '../Icon';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const ArrowButton = ({ text, onClick }) => (
  <Button variant="plain" onClick={onClick} icon={<Icon name="arrow" className={cn('arrow')} />}>
    <div className={cn('button-text')}>
      <Text size="size6-r" color="grey50">{text}</Text>
    </div>
  </Button>
);

ArrowButton.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
};

export default ArrowButton;
